import { executeRequest, Request } from '@jfs/network'
import { mimeTypes } from '../data/static/data'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  downloadFile(response, 'Bulk_Beneficiary')
  return response
}

const downloadFile = (resp: any, fileName: string) => {
  let contentType = resp.headers['content-type']
  if (mimeTypes.get(contentType) === undefined) {
    return
  } else {
    const blob = new Blob([resp?.data], { type: contentType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = url
    a.download = `${fileName}${mimeTypes.get(contentType)}`
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }
}

const bulkOnboardingFileDownload = (fileId: number, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.downloadBulkBeneficiaryFile,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      fileId: fileId,
      // type: 'BULK_BENEFICIARY',
    },
    responseType: 'arraybuffer',
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp))
    .catch((error) => {
      throw error
    })
}

export { bulkOnboardingFileDownload }
